export enum HeaderBlock {
  QUOTE_SETTINGS = 'QUOTE_SETTINGS',
  QUOTE_TOTALS = 'QUOTE_TOTALS',
  QUOTE_STATUS = 'QUOTE_STATUS'
}
